export const PACKAGES_DELETE_PACKAGE_OPEN_MODAL  = "PACKAGES_DELETE_PACKAGE_OPEN_MODAL";
export const PACKAGES_DELETE_PACKAGE_REQUEST  = "PACKAGES_DELETE_PACKAGE_REQUEST";
export const PACKAGES_DELETE_PACKAGE_RESULT  = "PACKAGES_DELETE_PACKAGE_RESULT";